/**
 * Checks for unsupported features
 */
const checks: (() => boolean)[] = [
    () => window.matchMedia("(prefers-reduced-data: reduce)").matches === true,
    () => typeof PerformanceObserver !== "function",
    () => typeof WeakRef !== "function",

    // There is only an ES6 build of the library
    () => (0, eval)("const o={},x={...o},y=(a,...r)=>null;false"),
];

/**
 * Check if the current environment is not supported
 */
export const abort = (): boolean => {
    try {
        return checks.some((check) => check());
    } catch (error) {
        return true;
    }
};
